import { stateGo } from 'redux-ui-router';
import { toggleFavouriteWorkout } from 'logic/favourite';
import { selectMember } from 'logic/member';

export const CardWorkout = {
  bindings: {
    workout: '<',
    member: '<',
    description: '<',
    type: '@',
    onClick: '&',
  },

  template: `
    <div class="card-workout card-wrapper pointer"
      ng-class="{ 'card-horizontal': $ctrl.type === 'horizontal' }"
      id="{{ $ctrl.workout.name | kebabCase }}">
      <card
        heading="$ctrl.workout.name"
        description="$ctrl.description"
        is-favourite="$ctrl.workout.isFavourite"
        img="$ctrl.workout.imageUrl.magazine"
        on-favourite="$ctrl.onFavourite($ctrl.member.id, $ctrl.workout)"
        on-click="$ctrl.onClick()">
          <badges>
            <card-badge-flame tags="$ctrl.workout.categories">
            </card-badge-flame>
          </badges>
          <footer-left>
            <i class="icon icon-time"></i>
            <span>{{ $ctrl.workout.totalTime.minutes }} min</span>
          </footer-left>
          <footer-right ng-if="$ctrl.workout.met">
            <i class="icon icon-calories-burnt"></i>
            <span>
              <workout-calories-burnt
                member="$ctrl.member"
                met="$ctrl.workout.met"
                total-time="$ctrl.workout.totalTime">
              </workout-calories-burnt> Cal
            </span>
          </footer-right>
        </card>
      </div>`,

  controller($ngRedux) {
    'ngInject';

    return {
      onFavourite(memberId, workout) {
        $ngRedux.dispatch(
          toggleFavouriteWorkout({
            memberId,
            workoutId: workout.id,
            isFavourite: workout.isFavourite,
          })
        );
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Card/CardWorkout.js